export default {"src":"/_next/static/media/get_doodle.4d72eff5.svg","height":278,"width":645,"blurWidth":0,"blurHeight":0};